import './toast.css';

const simple_toast = `
<div class="toast" id="toast-simple" role="alert">
    <div class="message">/SIMPLE_MESSAGE_CONTENT/</div>
</div>
`
let _toastTimer = null;
let _toastElement = null;
let _toastContainer = null;

export class Toast {
    /**
     * Shows a simple toast message and fades in and then out after 3s.
     * 
     * @param {string} message 
     */
    static showSimpleMessage(message) {
        setTimeout(function () {
            const toastHtml = simple_toast.replace("/SIMPLE_MESSAGE_CONTENT/", message);

            _toastContainer = document.createElement('div');
            _toastContainer.id = 'toast-container';
            _toastContainer.innerHTML = toastHtml;
            document.body.appendChild(_toastContainer);

            _toastElement = document.getElementById('toast-simple');
            _toastElement.classList.add('fade-in-up');

            _toastTimer = setTimeout(Toast.hideToast, 8000);
        }, 2250); // 1000ms delay before the toast shows up
    }

    static hideToast() {
        if (!_toastElement || !_toastContainer) return;
        _toastElement.classList.add('fade-out');

        const handleAnimationEnd = () => {
            if (_toastContainer) {
                _toastContainer.remove();
            }
            _toastElement = null;
            _toastContainer = null;
            _toastTimer = null;
            window.dispatchEvent(new Event('toastHidden'));
            _toastElement?.removeEventListener('animationend', handleAnimationEnd);
        };

        _toastElement.addEventListener('animationend', handleAnimationEnd, { once: true });
    }

    static dismissEarly() {
        if (_toastTimer) {
            clearTimeout(_toastTimer);
            _toastTimer = null;
        }
        Toast.hideToast();
    }
}
